// Replace <img ...> with [image]
export const stripImgTags = (html: string) => html.replace(/<img[^>]*>/gi, '[image]')

// Convert your mention spans to "@Label"
export const normalizeMentions = (html: string) =>
  html.replace(
    /<span[^>]*data-type=["']mention["'][^>]*data-label=["']([^"']+)["'][^>]*>.*?<\/span>/gi,
    (_m, label) => `@${label}`
  )

// Optional: collapse any remaining tags to plaintext
export const htmlToPlain = (html: string) =>
  html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
// utils (put near your component or in a shared util)
export const extractMentionIdsFromHtml = (html?: string) => {
  if (!html) return []
  const ids: string[] = []
  const re = /data-type=["']mention["'][^>]*\sdata-id=["']([^"']+)["']/gi
  let m
  while ((m = re.exec(html))) ids.push(m[1])
  return Array.from(new Set(ids))
}
export const convertHtmlToPlainText = (html: string) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  doc.querySelectorAll('[data-type="mention"]').forEach(el => {
    const label = el.getAttribute('data-label') || ''
    el.replaceWith(doc.createTextNode(`@${label}`))
  })
  // strip <img> entirely; Slack text should be clean
  doc.querySelectorAll('img').forEach(img => img.remove())
  return (doc.body.textContent || '').trim()
}
